var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"recos-view"},[_c('recommendations',{attrs:{"results":_vm.results},on:{"select":_vm.onPerfumeClick}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }